import { z } from 'zod';
export const EntityLabel = z.enum([
    'Person',
    'Organization',
    'GovernmentEntity',
    'RegulatoryFiling',
    'Asset',
    'Event',
    'Entity',
]);
/**
 * Canonical entity node. `name` is the canonical (usually Latin) name.
 * `nameFa` is the Persian form when available — the UI's <EntityName>
 * component renders both whenever present, per frontend spec §4.5.
 */
export const EntityNode = z.object({
    name: z.string(),
    nameFa: z.string().optional(),
    label: EntityLabel.default('Entity'),
});
/**
 * Confidence score for AI-generated claims and entity resolutions.
 * 0.0–1.0. Displayed via <ConfidenceMeter>, with thresholds:
 *   ≥0.85 high · ≥0.6 medium · <0.5 explicit warning.
 */
export const Confidence = z.number().min(0).max(1);
